var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "chatbot-window",
    attrs: {
      "role": "dialog",
      "aria-label": _vm.$t('sheet.chatbot.title').toString()
    }
  }, [_c('div', {
    staticClass: "chatbot-window__header"
  }, [_c('div', {
    staticClass: "chatbot-window__title-wrapper"
  }, [_vm._m(0), _c('div', [_c('h5', {
    staticClass: "chatbot-window__title"
  }, [_vm._v(" " + _vm._s(_vm.$t('sheet.chatbot.title')) + " ")]), _c('p', {
    staticClass: "chatbot-window__subtitle"
  }, [_vm._v(" " + _vm._s(_vm.$t('sheet.chatbot.subtitle')) + " ")])])]), _c('button', {
    staticClass: "chatbot-window__close",
    attrs: {
      "type": "button",
      "aria-label": _vm.$t('close').toString()
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('close');
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/modal/close-icon.svg"),
      "alt": ""
    }
  })])]), _c('div', {
    ref: "messagesContainer",
    staticClass: "chatbot-window__body"
  }, [!_vm.messages.length && !_vm.loading ? _c('div', {
    staticClass: "chatbot-window__message"
  }, [_c('p', {
    staticClass: "chatbot-window__message-title"
  }, [_vm._v(" " + _vm._s(_vm.$t('sheet.chatbot.empty-title')) + " ")]), _c('p', {
    staticClass: "chatbot-window__message-text"
  }, [_vm._v(" " + _vm._s(_vm.$t('sheet.chatbot.empty-text')) + " ")])]) : _vm._e(), _vm._l(_vm.messages, function (historyMessage) {
    return _c('div', {
      key: historyMessage.id,
      staticClass: "chatbot-window__message-row",
      class: {
        'chatbot-window__message-row--user': historyMessage.role === 'user'
      }
    }, [_c('div', {
      staticClass: "chatbot-window__message",
      class: {
        'chatbot-window__message--user': historyMessage.role === 'user',
        'chatbot-window__message--insufficient': _vm.isHighlightedAssistantMessage(historyMessage),
        'chatbot-window__message--error': historyMessage.status === 'ERROR'
      }
    }, [_vm.isInsufficientInformationMessage(historyMessage) ? _c('p', {
      staticClass: "chatbot-window__message-label"
    }, [_vm._v(" " + _vm._s(_vm.$t('sheet.chatbot.insufficient-label')) + " ")]) : _vm.isLimitReachedMessage(historyMessage) ? _c('p', {
      staticClass: "chatbot-window__message-label"
    }, [_vm._v(" " + _vm._s(_vm.$t('sheet.chatbot.limit-reached-label')) + " ")]) : _vm.isDisabledMessage(historyMessage) ? _c('p', {
      staticClass: "chatbot-window__message-label"
    }, [_vm._v(" " + _vm._s(_vm.$t('sheet.chatbot.disabled-label')) + " ")]) : _vm._e(), historyMessage.role === 'user' ? _c('p', {
      staticClass: "chatbot-window__message-text"
    }, [_vm._v(" " + _vm._s(historyMessage.text) + " ")]) : _vm.isLimitReachedMessage(historyMessage) ? _c('div', {
      staticClass: "chatbot-window__message-text"
    }, [_vm._v(" " + _vm._s(_vm.$t('chat.ai.limit-reached-before-email')) + " "), _c('a', {
      staticClass: "chatbot-window__message-link",
      attrs: {
        "href": _vm.supportEmailHref
      }
    }, [_vm._v(" " + _vm._s(_vm.supportEmail) + " ")]), _vm._v(" " + _vm._s(_vm.$t('chat.ai.limit-reached-after-email')) + " ")]) : _c('div', {
      staticClass: "chatbot-window__message-text chatbot-window__message-text--markdown",
      domProps: {
        "innerHTML": _vm._s(_vm.renderAssistantMessage(_vm.getHistoryMessageText(historyMessage)))
      }
    })])]);
  }), _vm.loading ? _c('div', {
    staticClass: "chatbot-window__message-row chatbot-window__message-row--loading"
  }, [_c('div', {
    staticClass: "chatbot-window__message"
  }, [_c('div', {
    staticClass: "chatbot-window__loading"
  }, [_c('b-spinner', {
    attrs: {
      "small": "",
      "variant": "primary",
      "label": _vm.$t('sheet.chatbot.loading').toString()
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('sheet.chatbot.loading')))])], 1)])]) : _vm._e(), _vm.technicalError ? _c('div', {
    staticClass: "chatbot-window__technical-error",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v(" " + _vm._s(_vm.technicalError) + " ")]) : _vm._e()], 2), _c('div', {
    staticClass: "chatbot-window__footer"
  }, [_c('b-form', {
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "chatbot-window__input-wrapper"
  }, [_c('b-form-textarea', {
    staticClass: "chatbot-window__input",
    attrs: {
      "no-resize": "",
      "rows": "3",
      "max-rows": "6",
      "placeholder": _vm.$t('sheet.chatbot.input-placeholder'),
      "disabled": _vm.loading,
      "state": _vm.inputState
    },
    on: {
      "input": _vm.onInput,
      "keydown": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        if ($event.ctrlKey || $event.shiftKey || $event.altKey || $event.metaKey) return null;
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments);
      }
    },
    model: {
      value: _vm.message,
      callback: function ($$v) {
        _vm.message = $$v;
      },
      expression: "message"
    }
  }), _vm.validationMessage ? _c('b-form-invalid-feedback', {
    staticClass: "d-block",
    attrs: {
      "state": false
    }
  }, [_vm._v(" " + _vm._s(_vm.validationMessage) + " ")]) : _vm._e(), _c('div', {
    staticClass: "chatbot-window__input-meta"
  }, [_c('span', {
    staticClass: "chatbot-window__input-hint"
  }, [_vm._v(" " + _vm._s(_vm.$t('sheet.chatbot.input-hint')) + " ")]), _c('span', {
    staticClass: "chatbot-window__char-count",
    class: {
      'chatbot-window__char-count--danger': _vm.isTooLong
    }
  }, [_vm._v(" " + _vm._s(_vm.message.length) + "/" + _vm._s(_vm.maxMessageLength) + " ")])])], 1), _c('div', {
    staticClass: "chatbot-window__actions"
  }, [_c('b-button', {
    staticClass: "chatbot-window__send",
    attrs: {
      "variant": "primary",
      "type": "submit",
      "disabled": _vm.isSubmitDisabled
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('sheet.chatbot.send')) + " ")])], 1)])], 1)]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "chatbot-window__icon-wrapper"
  }, [_c('img', {
    staticClass: "chatbot-window__icon",
    attrs: {
      "src": require("@/assets/sheet/chatbot-icon-white.svg"),
      "alt": ""
    }
  })]);

}]

export { render, staticRenderFns }